import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { c as collapsibleListStyles } from './collapsible-list-component.rtlignore.js';

function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }
  return a;
};
var ArrowIcon = function ArrowIcon(props) {
  return /* @__PURE__ */React.createElement("svg", __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /* @__PURE__ */React.createElement("g", {
    fillRule: "evenodd"
  }, /* @__PURE__ */React.createElement("g", null, /* @__PURE__ */React.createElement("g", null, /* @__PURE__ */React.createElement("g", null, /* @__PURE__ */React.createElement("g", null, /* @__PURE__ */React.createElement("path", {
    d: "M11.999 9L6 14.241 6.657 15 11.999 10.334 17.343 15 18 14.241z",
    transform: "translate(-129 -185) translate(97 105) translate(23 71) rotate(-90 21 12) matrix(1 0 0 -1 0 24)"
  })))))));
};

function ExpandCollapseButton(props) {
  var onClick = props.onClick,
    idx = props.idx,
    ariaLabel = props.ariaLabel;
  return (
    //using 'div' element instead of 'button' to fix a bug of focus on element in Firefox in OSX
    // further reading, https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Clicking_and_focus#Clicking_and_focus
    /* @__PURE__ */
    React.createElement("div", {
      role: "button",
      tabIndex: -1,
      className: collapsibleListStyles.iconContainer,
      onClick: onClick,
      onKeyUp: function onKeyUp(e) {
        return (e.key === " " || e.key === "Enter") && onClick(e);
      },
      "data-hook": "ExpandCollapseButton_" + idx
    }, /* @__PURE__ */React.createElement(ArrowIcon, {
      role: "button",
      tabIndex: "0",
      "aria-label": ariaLabel,
      className: classNames(collapsibleListStyles.icon, props.isExpanded && collapsibleListStyles.isExpanded)
    }))
  );
}
ExpandCollapseButton.propTypes = {
  isExpanded: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  idx: PropTypes.string,
  ariaLabel: PropTypes.string
};

export { ExpandCollapseButton as E };

import 'wix-rich-content-plugin-collapsible-list/dist/loadable/viewer/es/styles.viewer.min.global.css'